// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-container {
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem;
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(102, 22, 205, 0.1);
}

.feedback-container h2 {
  color: #6616cd;
  text-align: center;
  margin-bottom: 2rem;
}

.rating-container {
  text-align: center;
  margin-bottom: 2rem;
}

.rating-container p {
  margin-bottom: 1rem;
  color: #666;
}

.star-rating {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.star-rating input[type="radio"] {
  display: none;
}

.star {
  cursor: pointer;
  font-size: 2.5rem;
  color: #e4e5e9;
  transition: color 0.2s ease;
}

.star.active,
.star:hover {
  color: #ffc107;
}

.feedback-input {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

select {
  padding: 0.8rem;
  border: 2px solid #eee;
  border-radius: 8px;
  font-family: inherit;
  color: #333;
}

select:focus {
  border-color: #6616cd;
  outline: none;
}

textarea {
  width: 100%;
  min-height: 150px;
  padding: 1rem;
  border: 2px solid #eee;
  border-radius: 8px;
  font-family: inherit;
  resize: vertical;
}

textarea:focus {
  border-color: #6616cd;
  outline: none;
}

button[type="submit"] {
  width: 100%;
  padding: 1rem;
  background: #6616cd;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

button[type="submit"]:hover {
  background: #5512a8;
  transform: translateY(-2px);
}

button[type="submit"]:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
}

.success-message {
  text-align: center;
  color: #4CAF50;
}

.success-message h3 {
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .feedback-container {
    margin: 1rem;
    padding: 1.5rem;
  }
  
  .star {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Feedback/FeedbackForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".feedback-container {\n  max-width: 600px;\n  margin: 2rem auto;\n  padding: 2rem;\n  background: white;\n  border-radius: 15px;\n  box-shadow: 0 5px 15px rgba(102, 22, 205, 0.1);\n}\n\n.feedback-container h2 {\n  color: #6616cd;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.rating-container {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.rating-container p {\n  margin-bottom: 1rem;\n  color: #666;\n}\n\n.star-rating {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.star-rating input[type=\"radio\"] {\n  display: none;\n}\n\n.star {\n  cursor: pointer;\n  font-size: 2.5rem;\n  color: #e4e5e9;\n  transition: color 0.2s ease;\n}\n\n.star.active,\n.star:hover {\n  color: #ffc107;\n}\n\n.feedback-input {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\nselect {\n  padding: 0.8rem;\n  border: 2px solid #eee;\n  border-radius: 8px;\n  font-family: inherit;\n  color: #333;\n}\n\nselect:focus {\n  border-color: #6616cd;\n  outline: none;\n}\n\ntextarea {\n  width: 100%;\n  min-height: 150px;\n  padding: 1rem;\n  border: 2px solid #eee;\n  border-radius: 8px;\n  font-family: inherit;\n  resize: vertical;\n}\n\ntextarea:focus {\n  border-color: #6616cd;\n  outline: none;\n}\n\nbutton[type=\"submit\"] {\n  width: 100%;\n  padding: 1rem;\n  background: #6616cd;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\nbutton[type=\"submit\"]:hover {\n  background: #5512a8;\n  transform: translateY(-2px);\n}\n\nbutton[type=\"submit\"]:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.success-message {\n  text-align: center;\n  color: #4CAF50;\n}\n\n.success-message h3 {\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 768px) {\n  .feedback-container {\n    margin: 1rem;\n    padding: 1.5rem;\n  }\n  \n  .star {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
